import PromoCodes from './PromoCodes';

const PromoAnalytics = () => {
  return <PromoCodes mode="analytics" />;
};

export default PromoAnalytics;
